export const GET_TEAM_UNAVAILABILITY = "GET_TEAM_UNAVAILABILITY"
export const GET_TEAM_UNAVAILABILITY_SUCCESS = "GET_TEAM_UNAVAILABILITY_SUCCESS"
export const GET_TEAM_UNAVAILABILITY_FAIL = "GET_TEAM_UNAVAILABILITY_FAIL"

export const ADD_TEAM_UNAVAILABILITY = "ADD_TEAM_UNAVAILABILITY"
export const ADD_TEAM_UNAVAILABILITY_SUCCESS = "ADD_TEAM_UNAVAILABILITY_SUCCESS"
export const ADD_TEAM_UNAVAILABILITY_FAIL = "ADD_TEAM_UNAVAILABILITY_FAIL"

export const UPDATE_TEAM_UNAVAILABILITY = "UPDATE_TEAM_UNAVAILABILITY"
export const UPDATE_TEAM_UNAVAILABILITY_SUCCESS = "UPDATE_TEAM_UNAVAILABILITY_SUCCESS"
export const UPDATE_TEAM_UNAVAILABILITY_FAIL = "UPDATE_TEAM_UNAVAILABILITY_FAIL"

export const DELETE_TEAM_UNAVAILABILITY = "DELETE_TEAM_UNAVAILABILITY"
export const DELETE_TEAM_UNAVAILABILITY_SUCCESS = "DELETE_TEAM_UNAVAILABILITY_SUCCESS"
export const DELETE_TEAM_UNAVAILABILITY_FAIL = "DELETE_TEAM_UNAVAILABILITY_FAIL"

export const SET_TEAM_UNAVAILABILITY_FIELD_ERRORS = "SET_TEAM_UNAVAILABILITY_FIELD_ERRORS"
